import { render } from "./GS1Link.vue?vue&type=template&id=375d8717&scoped=true"
import script from "./GS1Link.vue?vue&type=script&lang=js"
export * from "./GS1Link.vue?vue&type=script&lang=js"

import "./GS1Link.vue?vue&type=style&index=0&id=375d8717&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375d8717"]])

export default __exports__